import { Button } from "@sellar-io/components";
import { Icon } from "../../../components";
import { Alert } from "../../../components/alert/Alert";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { usePayoutCreateRyftAccountUrl } from "../../../hooks/api/v2/payout/usePayoutCreateRyftAccountUrl";
import { IntegrationCard } from "./IntegrationCard";

export const RyftIntegrationSettings = () => {
  const payoutGetRyftAccountUrlMutation = usePayoutCreateRyftAccountUrl();

  const onSubmit = () => {
    return payoutGetRyftAccountUrlMutation.mutate(undefined, {
      onSuccess: (data) => {
        window.open(data.url);
      },
    });
  };
  return (
    <IntegrationCard
      appImage={
        "https://sellar.imgix.net/sellar-image-assets/app-assets/ryft-logo.png"
      }
      title={"Ryft"}
      description={
        "Receive and manage payouts for orders paid for by Sellar Credit."
      }
      actions={
        <>
          <Button
            loading={payoutGetRyftAccountUrlMutation.isPending}
            onClick={onSubmit}
          >
            <Icon icon={"OPEN_IN_NEW"} />
            Go to dashboard
          </Button>
          <Button
            color={"secondary"}
            onClick={() =>
              window.open(
                "https://intercom.help/sellario/en/articles/10568667-supplier-guide-sign-up-to-be-paid-from-sellar-credit",
                "_blank",
              )
            }
          >
            <Icon icon={"OPEN_IN_NEW"} />
            VIEW SETUP GUIDE
          </Button>
        </>
      }
    >
      {payoutGetRyftAccountUrlMutation.isError ? (
        <Alert
          type={"error"}
          className={"w-full"}
          message={
            apiV2AssertError(payoutGetRyftAccountUrlMutation.error)?.response
              ?.data.message ?? "Unknown error"
          }
        />
      ) : null}
    </IntegrationCard>
  );
};
